var React = require('react');

function EmptyProfile (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#fff;}")),React.createElement("polygon",{"className":"cls-1","points":"403.96 210.81 647.8 210.81 445.66 472.31 567.28 448.54 237.87 852.68 386.19 548.09 285.08 570.38 403.96 210.81","key":1})]);
}

EmptyProfile.defaultProps = {"id":"Final","viewBox":"0 0 840.99 1021.99"};

module.exports = EmptyProfile;

EmptyProfile.default = EmptyProfile;
